import Address = Account.Addresses.Address;
import BillingAddress = Account.Billing.BillingAddress;
import styles from "@/app/checkout/(squeeze)/review/checkoutReviewOrderDetails.module.scss";

export default function CheckoutReviewOrderDetailsAddressDisplay({
  address,
  isShipping,
}: CheckoutReviewOrderDetailsAddressDisplayProps) {
  return (
    <>
      <div className={isShipping ? styles.name : styles.line}>{address.Name}</div>
      {address.CompanyName && <div className={styles.line}>{address.CompanyName}</div>}
      <div className={styles.line}>
        {address.Streets[0] && `${address.Streets[0]}, `} {address.Streets[1] && `${address.Streets[1]}, `}
        {address.City && `${address.City} `} {address.RegionCD} {address.PostalCD}
      </div>
      {isShipping && <div className={styles.line}>Phone: {address.PhoneNumber}</div>}
    </>
  );
}

export type CheckoutReviewOrderDetailsAddressDisplayProps = {
  address: Address | BillingAddress;
  isShipping: boolean;
};
